export default {
    data() {
        return {
            form: {
                valid: false
            }
        }
    },
    watch: {
        'form.fields': {
            handler() {
                this.form.valid = !Object.values(this.form.fields).some(({valid}) => valid === false)
                this.$emit('update:valid', this.form.valid)
            },
            deep: true
        }
    },
    emits: ['update:valid']
}